export var StandardRoomType = function (StandardRoomType) {
  StandardRoomType["DB"] = "Double";
  StandardRoomType["FAM"] = "Family";
  StandardRoomType["DIS"] = "Accessible";
  StandardRoomType["SB"] = "Single";
  StandardRoomType["TWIN"] = "Twin";
  return StandardRoomType;
}({});